export const NotFoundPage = () =>
    <div className="page">
        Sorry you're lost! Sucks for you!
    </div>;